import React from "react";
import "./styles.css";

function Info(props) {
  return (
    <div className="container-mobile">
      <div
        className="white-box"
        style={{
          height: "auto",
          marginBottom: "-15px",
          padding: "0px",
          borderRadius: "5px",
          boxShadow: "none",
        }}
      >
        <div className="locais">
          <div className="imagem-container">
            <img
              src={"data:image/jpeg;base64," + props.imagemURL}
              width="95"
              id="base64image"
            />
          </div>
          <div className="textoLocais">
            <b> {props.nomeLocal} </b>
            <p> {props.endereco}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Info;
